module.exports = __webpack_public_path__ + "static/haztares-about-1-044071d4fb97bb988efe1e25f219da39.jpeg";